// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__ZvjTK","tab":"ProcedureTabs_tab__3vS3y"};